import { QrCode, Headset, LayoutGrid, ShieldCheck, Smartphone } from "lucide-react";

// Set `image` to a URL to swap the icon for a real photo — the media tile keeps its size.
export const HELPER_ROLE_INFO = {
  helper_seat: {
    title: "Check-In Helper", icon: QrCode, image: null,
    description: "Greets players on arrival, helps them register on the app, reveals their QR code for self-check-in, confirms they're checked in, and points them to the right playing area with a quick briefing on how the day works.",
  },
  roster_ops_seat: {
    title: "OPS Assist", icon: Headset, image: null,
    description: "Manages player availability without needing a phone or self-service. Players queue at an OPS Assist desk or find their assigned OPS person to be marked available for play or assigned to a coaching session — keeping things moving without the formality.",
  },
  ops_seat: {
    title: "Court Operations", icon: LayoutGrid, image: null,
    description: "Handles everything on the court side — managing court assignments, inputting coaching sessions, and all the functions of Check-In Helper and OPS Assist combined. The go-to role for keeping the day running smoothly.",
  },
  deputy_seat: {
    title: "Deputy Admin", icon: ShieldCheck, image: null,
    description: "Full operational control. Can update player details (name, gender, rating), purchase additional add-ons on behalf of players, and perform all functions of every role above.",
  },
  self_service: {
    title: "Self-Service", icon: Smartphone, image: null, useLabel: true,
    description: "Players manage their own festival experience from their phone. Mark yourself as available, resting, or done for the day, view court allocations and schedules, browse and book coaching sessions, and send partner or opponent playing requests — all without needing to queue at a desk.",
  },
};

export function RoleMedia({ info, testId }) {
  const Icon = info.icon;
  return (
    <div className="w-12 h-12 sm:w-14 sm:h-14 shrink-0 border border-[#262626] bg-[#CCFF00]/5 flex items-center justify-center overflow-hidden" data-testid={testId}>
      {info.image
        ? <img src={info.image} alt={info.title} className="w-full h-full object-cover" />
        : <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-[#CCFF00]" strokeWidth={1.5} />}
    </div>
  );
}
